const initialState = {
  loading: true, // true for the first time only
  data: [],
  error: null,
  hasFetchedOnce: false // <-- track if the first fetch is done
};

const Reducer911 = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_LOCKDOWN_DETAILS_LOADING":
      return {
        ...state,
        // show loading only for first fetch
        loading: !state.hasFetchedOnce,
        error: ""
      };

    case "FETCH_LOCKDOWN_DETAILS_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: "",
        hasFetchedOnce: true // mark first fetch as done
      };

    case "FETCH_LOCKDOWN_DETAILS_ERROR":
      return {
        ...state,
        loading: false,
        error: action.payload,
        hasFetchedOnce: true
      };

    default:
      return state;
  }
};

export default Reducer911;
